import { setFulfilled, setPending, setRejected } from '@ms/yammer-data-support';
import { Reducer } from 'redux';

import { NetworkExternalSettingsAction } from '../../../domains/networkExternalSettings/actions.types';

import { NetworkExternalSettings } from './types';

export type { NetworkExternalSettingsAction };

const initialState: NetworkExternalSettings = {
  pending: false,
  fulfilled: undefined,
  rejected: undefined,
};

const reducer: Reducer<NetworkExternalSettings, NetworkExternalSettingsAction> = (state = initialState, action) => {
  switch (action.type) {
    case 'NETWORK_EXTERNAL_SETTINGS.LOAD_PENDING':
      return setPending();
    case 'NETWORK_EXTERNAL_SETTINGS.LOAD_FULFILLED':
      return setFulfilled(action.payload.networkExternalSettings);
    case 'NETWORK_EXTERNAL_SETTINGS.LOAD_REJECTED':
      return setRejected(action.payload.error);
    default:
      return state;
  }
};

export default reducer;
